export const state = () => ({
  is_online: true,
  is_screen_lock: false
});

export const mutations = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 28 Sep 2023 | 03:56PM
   * @param {*} state
   * @param {*} value
   */
  changeSystemOnline(state, value) {
    state.is_online = value;
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 19 Mar 2025 | 10:30AM
   * @param {*} state
   * @param {*} value
   */
  setScreenLock(state, value) {
    state.is_screen_lock = value;
  }
};

export const actions = {
  graphqlError(__, message) {
    this.$toaster.error(message);
  }
};

export const getters = {
  is_online: (state) => state.is_online,
  is_screen_lock: (state) => state.is_screen_lock
};
